import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { connect } from '../lib/keaConnect'
import ReactPlaceholder from 'react-placeholder'
import querystring from 'querystring'
import appLogic from '@otavamedia/om-component-library/lib/kea/application'
import Resolver from './Resolver'
import IndexHighlights from '../components/views/IndexHighlights'
import Sidebar from '../components/views/Sidebar'
import NewsfeedLoader from '../components/general/util/NewsfeedLoader'
import PostList from '../components/general/lists/PostList'
import ArticleListItem from '../components/general/article/ArticleListItem'
import Breakpoint from '@otavamedia/om-component-library/lib/util/Breakpoint'
import track from 'react-tracking'
import TopRowAd from '../components/general/util/TopRowAd'
import WP from '@otavamedia/om-component-library/lib/lib/WP'
import get from 'lodash/get'
import some from 'lodash/some'
import IndexSidebar from '../components/views/IndexSidebar'
import TopPicks from '../components/widgets/TopPicks'
import LatestPosts from '../components/general/popular/LatestPosts'
import CatchList from '../components/widgets/CatchList'
import { indexLayout as layout } from '../lib/defaults'
import { pushPageDataToGTM } from '@otavamedia/om-component-library/lib/lib/utils'
import GAMNativeAdHolder from '../components/widgets/GAMNativeAdHolder'
import {
  AdsForDesktop,
  AdsForMobile,
  AdSlotDesk2,
  AdSlotMob2,
} from '../components/general/ads/Ads'
import RandomArticle from '../components/widgets/RandomArticle'

import './Index.scss'

export default @track({ gtmContext: ['FrontPage'] })
@connect({
  props: [
    appLogic, [
      'settings',
    ],
  ]
})
class Index extends Component {
  loaded = {
    sidebar: false,
    mainContent: false,
  }

  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      error: false,
      highlights: [],
      stickies: [],
      exclude: [],
      nativeAds: []
    }
  }

  static propTypes = {
    settings: PropTypes.object,
    match: PropTypes.object,
    setRendered: PropTypes.func.isRequired,
    history: PropTypes.object,
    location: PropTypes.object,
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    this.setState({ page: parseInt(get(newProps, 'match.params.page')) || 1 })
  }

  async componentDidMount () {
    pushPageDataToGTM({ type: 'index' })
    try {
      const [{ highlights, stickies }, editorsPicks] = await Promise.all([
        WP.getFrontpage(),
        WP.getEditorsPicks(),
      ])
      const exclude = highlights
        .map(x => x.item.id)
        .concat(stickies.map(x => x.id))

      // Is this block even needed?
      if (stickies.length < layout.highlights.stickyCount) {
        const offset = layout.highlights.stickyCount - stickies.length
        const { data: fill } = await WP.getForContext(WP.postTypes.post, { per_page: offset, exclude })

        fill.forEach(post => {
          stickies.concat(post)
          exclude.concat(post.id)
        })
      }

      this.setState({
        ready: true,
        highlights: highlights.concat(editorsPicks),
        stickies,
        exclude,
        error: false,
      }, () => this.doneLoading('mainContent'))
    } catch (e) {
      this.setState({ error: e })
    }
  }

  componentWillUnmount () {
    this.props.setRendered(false)
  }

  doneLoading (element) {
    if (this.loaded[element]) {
      return
    }
    this.loaded[element] = true
    if (!some(Object.values(this.loaded), (x) => !x)) {
      this.props.setRendered(true)
    }
  }

  render () {
    const { location, history } = this.props
    const { ready, highlights, stickies, exclude, error } = this.state
    const postListStickies = stickies ? stickies.slice(layout.highlights.stickyCount) : []

    if (location.search) {
      const qs = querystring.parse(location.search.substring(1))

      if (qs.p && qs.preview) {
        return <Resolver {...this.props} />
      }
    }

    return (
      <Fragment>
        <Helmet>
          <title>
            {window.om_constants.siteName}
          </title>
          <meta name="http:status" content="200" />
          <meta name="description" content="Erä-lehti tuo lukijoilleen tuoreimman tiedon riistamailta ja kalavesiltä. Artikkelit ennakoivat ja seuraavat tulevia ja käynnissä olevia jahti- ja kalastuskausia."/>
          <meta property="og:description" content="Erä-lehti tuo lukijoilleen tuoreimman tiedon riistamailta ja kalavesiltä. Artikkelit ennakoivat ja seuraavat tulevia ja käynnissä olevia jahti- ja kalastuskausia."/>
        </Helmet>
        <TopRowAd isArticleView={false} display={true}/>
        <TopPicks />
        <div styleName="main-content-col-wide">
          <div styleName="sub-container">
            <CatchList type="fish" cardsPerPage={6} compact={true}/>
            <div styleName="sub-row">
              <h2 className="screen-reader-text">Pääjutut</h2>
              <div id="service-worker-test">

              </div>
              <IndexHighlights error={error} highlights={highlights} stickies={stickies}
                layout={layout.highlights.boxes}/>
            </div>
          </div>
        </div>
        <aside styleName="sidebar-col-narrow">
          <Sidebar popular latestMag latestMagazine doneLoading={() => this.doneLoading('sidebar')}/>
        </aside>
        <Breakpoint maxBreakpoint={767}>
          <aside styleName="sidebar-col">
            <IndexSidebar doneLoading={() => this.doneLoading('indexSidebar')}/>
            <RandomArticle/>
          </aside>
        </Breakpoint>
        <div styleName="divider"/>
        <div styleName="full-width-col">
          <div className='row'>
            <AdsForDesktop>
              <AdSlotDesk2 />
            </AdsForDesktop>
            <AdsForMobile>
              <AdSlotMob2 />
            </AdsForMobile>
          </div>
        </div>
        <div styleName="main-content-col">
          <div styleName="sub-container">
            <div styleName="native-ads">
              <GAMNativeAdHolder grow={true} />
            </div>
            <LatestPosts compact/>
            <Breakpoint minBreakpoint={767}>
              <div styleName="native-ads">
                <GAMNativeAdHolder grow={true} type={2}/>
              </div>
            </Breakpoint>
            <ReactPlaceholder ready={ready || !!error} customPlaceholder={<NewsfeedLoader/>}>
              <div styleName="newsfeed">
                <main>
                  <PostList
                    context={{ link: 'latest' }}
                    layout={layout.newsFeed}
                    stickies={postListStickies}
                    ListItem={ArticleListItem}
                    onLoad={() => this.doneLoading('postlist')}
                    blacklist={exclude}
                    disablePagination={true}
                    history={history}
                    error={error}/>
                </main>
              </div>
            </ReactPlaceholder>
          </div>
        </div>
        <Breakpoint minBreakpoint={768}>
          <aside styleName="sidebar-col">
            <IndexSidebar doneLoading={() => this.doneLoading('indexSidebar')}/>
            <RandomArticle/>
          </aside>
        </Breakpoint>
      </Fragment>
    )
  }
}
